import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  signInUrl = environment.signInUrl;
  signUpUrl = environment.signUpUrl
  applyNowUrl = environment.applyNowUrl;
  isMenuOpen ?: boolean = false;
  constructor(@Inject(DOCUMENT) private document: Document) { }
  menuOpen(){
    this.isMenuOpen = !this.isMenuOpen;
  }
  signmenu(event:any){
    console.log(event);
  }


  ngOnInit(): void {
    this.isMenuOpen = false;
  }
  redirect(url: string) {
    window.location.replace(url);
  }
}
